<template>
  <div class="main">
    <el-dialog
      :title="datas.title"
      :visible.sync="show"
      width="800px"
      class="dialog_container printing"
      @close="dialogClose"
    >
      <el-form
        label-position="left"
        label-width="120px"
        ref="formData"
        :model="addForm"
        :rules="addFormRules"
      >
        <el-form-item label="类型名称:">
          <el-input
            v-model="addForm.type"
            placeholder="类型名称"
          ></el-input>
        </el-form-item>
        <div class="queContent">
          <div
            class="itemQue"
            v-for="(item, index) in queList"
            :key="index"
          >
            <div class="itemMain">
              <div class="itemBox">
                <p class="name">问题：</p>
                <div class="itemContent">
                  <el-input
                    v-model="item.problems"
                    placeholder="请输入问题"
                  ></el-input>
                </div>
              </div>
              <div class="itemBox">
                <p class="name">回复问题：</p>
                <div class="itemContent">
                  <el-radio-group v-model="item.selections">
                    <el-radio label="0">是</el-radio>
                    <el-radio label="2">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="itemBox">
                <p class="name">原因：</p>
                <div class="itemContent">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    v-model="item.reasons"
                    placeholder="请输入服务内容"
                  ></el-input>
                </div>
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              icon="iconfont icon-xinzeng"
              class="btnHeight"
              @click="addGuardian(index)"
              v-if="index == 0"
            >新增</el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              class="btnHeight"
              @click="delGuardian(index)"
              v-else
            >关闭</el-button>
          </div>
        </div>
        <el-form-item label="发布类型:">
          <el-radio-group v-model="addForm.releaseType">
            <el-radio label="0">APP</el-radio>
            <el-radio label="1">公众号</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button
          type="primary"
          @click="save"
          :loading="subState"
        >确 定</el-button>
        <el-button @click="dialogClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { postQuestion, updateQuestion } from "../api/index.js"

export default {
  props: ["openData", "datas", "show"],
  data() {
    return {
      subState: false,
      title: "",
      addForm: { type: "", releaseType: "1" },
      addFormRules: {},
      queList: [{ problems: "", reasons: "", selections: "" }],
    }
  },
  created() {},

  methods: {
    // 新增表格信息
    addGuardian() {
      this.queList.push({ problems: "", reasons: "", selections: "" })
    },
    //删除表格信息
    delGuardian(index) {
      this.queList.splice(index, 1)
    },
    // 保存信息
    save() {
      let communityId = this.openData.commId
      this.subState = true
      let p = {
        communityId,
        ...this.addForm,
        problemList: this.queList,
      }

      let { id } = this.datas

      if (this.datas.title == "编辑") {
        updateQuestion({ ...p, id }).then(({ code, message }) => {
          if (code == 200) {
            this.$message({
              type: "success",
              message,
            })
            this.addForm = { type: "", releaseType: "1" }
            this.queList = [{ problems: "", reasons: "", selections: "" }]
            this.$parent.closeAddForm()
          }
          this.subState = false
        })
      } else {
        postQuestion(p).then(({ code }) => {
          if (code == 200) {
            this.$message({
              type: "success",
              message: "新增问题成功!",
            })
            this.addForm = { type: "", releaseType: "1" }
            this.queList = [{ problems: "", reasons: "", selections: "" }]
            this.$parent.closeAddForm()
          }
          this.subState = false
        })
      }
    },
    // 关闭人员信息
    dialogClose() {
      this.$parent.closeAddForm()
      this.addForm = { type: "", releaseType: "1" }
      this.queList = [{ problems: "", reasons: "", selections: "" }]
    },
  },
  watch: {
    show(n, o) {
      if (n && this.datas.title == "编辑") {
        let { problemList, type, releaseType } = this.datas
        this.queList = problemList
          ? problemList
          : [{ problems: "", reasons: "", selections: "" }]
        this.addForm["type"] = type
        this.addForm["releaseType"] = releaseType
      }
    },
  },
}
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.mt25 {
  margin-top: 25px;
}
.itemBox {
  display: flex;
  margin-bottom: 24px;
  .name {
    width: 120px;
  }
  .itemContent {
    flex: 1;
    width: 0;
  }
}
.itemQue {
  display: flex;
  .itemMain {
    flex: 1;
    width: 0;
    margin-right: 12px;
  }
}
.btnHeight {
  height: 40px;
}
</style>